module.exports = __webpack_public_path__ + "static/media/39.21a1a793.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/39.jpg
// module id = 572
// module chunks = 0